/** Service Desk console: Mga tab ng Service settings para sa after-sales (Assets at warranty, Mga template ng bisita; SD-S3-10). */
export const serviceAfterSalesSettings = {
  nav: { assets: "Mga asset at warranty", "visit-templates": "Mga template ng bisita" },
  assetsWarranty: {
    window: {
      title: "Warranty window",
      intro: "Nagiging Malapit nang mag-expire ang asset sa bilang ng araw na ito bago matapos ang warranty nito. Ang standard ay {{default}} araw.",
      label: "Araw bago matapos",
      hint: "Buong bilang mula {{min}} hanggang {{max}}.",
      problem: "Maglagay ng buong bilang ng araw mula {{min}} hanggang {{max}}.",
      save: "I-save ang window",
      saved: "Na-save ang warranty window.",
    },
    categories: {
      title: "Mga kategorya ng asset",
      intro: "Ang mga kategoryang mapaglalagyan ng asset. Galing ang mga ito sa industry pack mo; iniaalok ng form ng asset at ng listahan ng mga asset.",
      none: "Wala pang kategorya. Magdaragdag ng panimulang listahan ang pag-apply ng industry pack; hangga't wala, malayang teksto ang kategorya ng asset.",
      count_one: "{{count}} kategorya",
      count_other: "{{count}} kategorya",
    },
    words: {
      title: "Mga salita para sa asset at proyekto",
      intro: "Palitan ang mga salitang ginagamit ng mga screen ng after-sales, ng portal at ng mga e-mail. Iwanang walang laman para panatilihin ang standard na salita.",
    },
  },
  visitTemplates: {
    intro: "Ang mga checklist na pinagsisimulan ng isang bisita. Kasama ang mga ito sa workspace mo at hindi puwedeng i-edit dito.",
    forCategory: "Para sa {{category}}",
    anyCategory: "Para sa anumang asset",
    kind: { corrective: "Corrective", pm: "Preventive maintenance", calibration: "Calibration", installation: "Installation", inspection: "Inspeksyon", training: "Training" },
    inactive: "Hindi ginagamit",
    checklist: "Checklist ng {{name}}",
    emptyTitle: "Walang template ng bisita",
    emptyBody: "Lalabas dito ang mga checklist ng bisita kapag na-set up na ang mga ito para sa workspace mo.",
  },
} as const;
